
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface GatewayPerformanceProps {
  device: any;
}

const GatewayPerformance: React.FC<GatewayPerformanceProps> = ({ device }) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Gateway Performance</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">CPU Usage</p>
            <p className="text-lg font-bold">{device.cpuUsage}%</p>
          </div>
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Memory Usage</p>
            <p className="text-lg font-bold">{device.memoryUsage}%</p>
          </div>
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Temperature</p>
            <p className="text-lg font-bold">{device.temperatureCelsius}°C</p>
          </div>
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Connected Devices</p>
            <p className="text-lg font-bold">{device.connectedDevices}</p>
          </div>
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Uptime</p>
            <p className="text-lg font-bold">{Math.floor(device.uptimeHours / 24)}d {device.uptimeHours % 24}h</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default GatewayPerformance;
